import ConnectForm from './ConnectForm';
import FormModal from './FormModal';
import { Button, Modal } from './';

import React from 'react';
import PropTypes from 'prop-types';

const ConnectModal = ({ id, trigger /*, meta*/, onConnect }) => {
  const defaultValues = {
    address: window.location.host || 'localhost',
  };

  const Actions = ({ formProps, modal }) => (
    <Modal.Actions>
      <Button form={formProps.id} floated="right" positive>
        Connect
      </Button>
      <Button onClick={modal.onCancel}>Cancel</Button>
      <Button onClick={modal.onReset} floated="left">
        Reset
      </Button>
    </Modal.Actions>
  );

  const onSubmit = values => onConnect({ ...defaultValues, ...values });

  return (
    <FormModal
      id={`${id}--form`}
      trigger={trigger}
      header="Connect to network"
      Form={ConnectForm}
      Actions={Actions}
      defaultValues={defaultValues}
      //meta={meta}
      onSubmit={onSubmit}
    />
  );
};

ConnectModal.propTypes = {
  id: PropTypes.string.isRequired,
  trigger: PropTypes.element.isRequired,
  //meta: PropTypes.object.isRequired,
  onConnect: PropTypes.func.isRequired,
};

export default ConnectModal;



// WEBPACK FOOTER //
// ./src/components/ConnectModal.js